const hometestimonials = [
    {
      quote:
        "Ampstek pay has completely transformed our recruitment and onboarding process. The platform’s intuitive interface made it easy to attract, manage, and engage top talent from all over the globe. With automated workflows, our HR team can now focus on building relationships rather than handling tedious administrative tasks. New hires are quickly onboarded with all necessary documentation and training materials, ensuring a smooth start. Thanks to Ampstek pay, we’ve enhanced our talent acquisition efficiency and reduced onboarding time significantly.",
      author: "Ram Gopal",
      position: "Talent Acquisition Manager - United Kingdom",
    },
    {
      quote:
        "Ampstek pay has helped us save an incredible amount of time on recruitment, onboarding, and payroll. With automated systems and compliance tools, we no longer need to manually manage these complex processes. The platform provides us with error-free payroll calculations, while new hires can complete their paperwork and training before they even start. This level of efficiency means we can focus on nurturing talent and driving our business forward, while Ampstek pay handles the rest.",
      author: "Riya Raj",
      position: "Account Manage -Princeton, NJ, US",
    },
  ];

  const homesliderContent = {
    heading: "World-Class Companies Trust Us for Their Global Hiring Needs",
    subtitle:
      "Ampstek pay delivers end-to-end HR solutions. Discover how our platform has helped clients streamline recruitment and payroll for a truly global workforce.",
  };


  const staffingtestimonials = [
    {
      quote:
        "Our HR team has seen a massive improvement in efficiency with Ampstek pay. The platform’s easy-to-use recruitment system allows us to quickly source and screen candidates, while its onboarding tools ensure that our new hires are set up for success right from the start. Global payroll has been made simple, reducing the administrative burden on our finance team. Employees also love the transparency—everything they need, from pay stubs to benefits information, is available at their fingertips. Ampstek pay has empowered both our HR team and our employees to thrive.",
      author: "Manav Pattnaik",
      position: "Director Operations- Chennai, TN, IN",
    },
    {
      quote:
        "As our company expanded into new international markets, managing payroll for a diverse, global team became a challenge. Ampstek pay stepped in and simplified the entire process. With its seamless integration of recruitment, onboarding, and global payroll, we now have one platform that can scale as we grow. The system’s ability to handle multiple countries with different regulations, currencies, and tax rules gives us confidence in compliance and efficiency. Ampstek pay has been a key enabler of our growth strategy.",
      author: "Ramalakshmi A.",
      position: "PeopleSoft Consultant at Ampstek - Adelaide, SA, AU",
    },
  ];

  const staffingslidercontent = {
    heading: "Global Companies We’ve Partnered With for Hiring",
    subtitle:
      "Our platform powers global HR success. Discover how Ampstek pay enables businesses to onboard and pay employees effortlessly across borders.Driving Success for Global Enterprises with Our Seamless Hiring Solutions",
  };


  const companytestimonials = [
    {
      quote:
        "The logistics in the US are quite hard and I don't think we would have been able to do it without a partner like Ampstek pay to help and essentially take that employment burden off us.                                     ",
      author: "",
      position: "",
    },
    {
      quote:
        "Working with an appropriate EOR like Ampstek pay in North America really gives us the ability to give our team the best experience.                                     ",
      author: "",
      position: "",
    },
   
  ];

  const companyslidercontent = {
    heading: "A Trusted Partner for International Hiring",
    subtitle:
      "",
  };
  export { hometestimonials, homesliderContent,staffingtestimonials, staffingslidercontent, companytestimonials ,companyslidercontent};